import cn from 'classnames';
import { FC } from 'react';

import { ClinicalCaseDescription } from './ClinicalCaseDescription/ClinicalCaseDescription';
import { ClinicalCaseDescriptionEditorModal } from './ClinicalCaseDescriptionEditorModal/ClinicalCaseDescriptionEditorModal';
import { PatientHistoricalData } from './PatientHistoricalData/PatientHistoricalData';
import styles from './PatientInfo.module.scss';
import { SharedWith } from './SharedWith/SharedWith';
import { TreatingDoctors } from './TreatingDoctors/TreatingDoctors';

type PatientInfoProps = {
  className?: string;
  patientID: string;
};

export const PatientInfo: FC<PatientInfoProps> = (props) => {
  const { className, patientID } = props;

  return (
    <div className={styles.container} data-section="patient-info">
      <div className={cn(styles.accessSection, className)}>
        <TreatingDoctors className={styles.accessCard} patientID={patientID} />

        <SharedWith className={styles.accessCard} patientID={patientID} />
      </div>

      <div className={styles.patientDetails}>
        <PatientHistoricalData patientID={patientID} />

        <ClinicalCaseDescription patientID={patientID} />
      </div>

      <ClinicalCaseDescriptionEditorModal />
    </div>
  );
};
